module.exports = __webpack_public_path__ + "img/buick.dd4bafb4.png";